'use strict';

var _ = require('lodash');

var getTotals = function getTotals(rows) {
  var isEMV = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var reachTotal = _.sumBy(_.values(rows), function (row) {
    return _.get(row, 'totals.reach');
  });
  var impressionsTotal = _.sumBy(_.values(rows), function (row) {
    var value = _.get(row, 'totals.impressions');
    if (!isEMV || value > 0) {
      return value;
    }
    return _.get(row, 'emv.estimatedImpressions', 0);
  });
  var engagementsTotal = _.sumBy(_.values(rows), function (row) {
    return _.get(row, 'totals.engagements');
  });
  var videoViewsTotal = _.sumBy(_.values(rows), function (row) {
    return _.get(row, 'totals.videoViews');
  });
  var impsEMVTotal = _.sumBy(_.values(rows), function (row) {
    var value = _.get(row, 'emv.impressionsEMV');
    if (!isEMV || value > 0) {
      return value;
    }
    return _.get(row, 'emv.estimatedImpressionsEMV', 0);
  });
  var engsEMVTotal = _.sumBy(_.values(rows), function (row) {
    return _.get(row, 'emv.engagementsEMV');
  });
  var impressionsCPM = _.meanBy(_.values(rows), function (row) {
    return _.get(row, 'costs.impressionsCPM', 0);
  });
  var engagementsCPM = _.meanBy(_.values(rows), function (row) {
    return _.get(row, 'costs.engsCPM', 0);
  });
  var viewsCPM = _.meanBy(_.values(rows), function (row) {
    return _.get(row, 'costs.viewsCPM', 0);
  });

  return {
    reachTotal: reachTotal,
    impressionsTotal: impressionsTotal,
    engagementsTotal: engagementsTotal,
    videoViewsTotal: videoViewsTotal,
    impsEMVTotal: impsEMVTotal,
    engsEMVTotal: engsEMVTotal,
    impressionsCPM: impressionsCPM,
    engagementsCPM: engagementsCPM,
    viewsCPM: viewsCPM
  };
};

module.exports = {
  getTotals: getTotals
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/utils/emv-utils.js
// module id = 267
// module chunks = 1